import React from "react";
import { cn } from "@/lib/utils";

interface SkeletonProps {
  className?: string;
  variant?: "text" | "title" | "paragraph" | "list-item" | "bullet";
  width?: string;
}

const Skeleton: React.FC<SkeletonProps> = ({ 
  className = "", 
  variant = "text",
  width = "w-full"
}) => {
  const baseClasses = "skeleton";
  const variantClasses = {
    text: "skeleton-text",
    title: "skeleton-title", 
    paragraph: "skeleton-paragraph",
    "list-item": "skeleton-list-item",
    bullet: "skeleton-bullet"
  };

  return (
    <div 
      className={cn(
        baseClasses,
        variantClasses[variant],
        width,
        className
      )}
    />
  );
};

export default Skeleton; 